/**
 * Typed view of a configurable-dashboard placement's layout, which rides the
 * existing widget-placements rail (ADR-0015): `position` on the placement
 * carries layout (`order`, `width`, `instanceId`); per-instance content
 * (`params`) rides the widget entity. `PlacementResponse.position` is a
 * free-form `Record<string, unknown> | null` on the wire, so this shape is
 * enforced by the consumer/validation layer, not the database.
 *
 * `width` is a named size that maps to a 12-column grid — the EntityDashboard
 * model. `instanceId` is stable across reorders and distinguishes multiple
 * instances of an `allowMultiple` widget (e.g. several pinned `singleKpi`s).
 */
export const WIDGET_WIDTHS = ["small", "medium", "wide", "full"];
/** 12-column grid span for each named width. */
export const WIDTH_TO_COLS = {
    small: 3,
    medium: 4,
    wide: 6,
    full: 12,
};
/** Narrowing guard for a raw width value read off the wire. */
export function isWidgetWidth(value) {
    return WIDGET_WIDTHS.includes(value);
}
/**
 * Parse a placement's free-form `position` blob into a typed
 * `WidgetPlacementPosition`. Returns `null` when the blob is absent or its
 * shape is invalid, so consumers can fall back rather than throw.
 */
export function parseWidgetPlacementPosition(raw) {
    if (typeof raw !== "object" || raw === null)
        return null;
    const { instanceId, order, width } = raw;
    if (typeof instanceId !== "string" || instanceId.length === 0)
        return null;
    if (typeof order !== "number" || !Number.isFinite(order))
        return null;
    if (!isWidgetWidth(width))
        return null;
    return { instanceId, order, width };
}
//# sourceMappingURL=widget-placement.js.map